import { Helmet } from '@dr.pogodin/react-helmet';
import { useParams } from 'react-router-dom';

import { Api } from '../../api';
import { PageError, PageLoading, PageWrap } from '../../components';
import { useSelectedCompany } from '../../contexts/ClientDataContext';
import { Model } from '../../models';
import ReleaseDetail from './ReleaseDetail';

export default function ReleasePage() {
  const { versionNumber } = useParams<{ versionNumber: string }>();
  const company = useSelectedCompany();

  const api = Api.Release.useReadItemDetailCompanySub(
    company.id,
    versionNumber!
  );
  if (api.error) return <PageError {...api} />;
  if (!api.data) return <PageLoading />;
  const release = api.data;

  return (
    <PageWrap limitWidth="small">
      <Helmet>
        <title>
          Release | {Model.Release.getVersionName(release)} | {company.name}
        </title>
      </Helmet>

      <ReleaseDetail
        release={release}
        listView={false}
        invalidate={api.invalidate}
      />
    </PageWrap>
  );
}
